import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllPositionWorkerUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllPositionWorker/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllPositionWorkerUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllPositionWorkerUser;
};


const setActivePositionWorker = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setPositionWorkerActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPositionWorkerUser = data;

    // console.log('Сервер вернул данные по обновлению статуса PositionWorker  - ',response);


    return AllPositionWorkerUser;
};



const setDeletedPositionWorker = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setPositionWorkerDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPositionWorkerUser = data;

    // console.log('Сервер вернул данные по обновлению статуса PositionWorker  - ',response);


    return AllPositionWorkerUser;
};




const setUpdatePositionWorker = async (dataPositionWorkerUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setPositionWorkerUpdate/'),{
        dataPositionWorkerUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPositionWorkerUser = data;

    // console.log('Сервер вернул данные по обновлению статуса PositionWorker  - ',dataPositionWorkerUpdate,response);


    return AllPositionWorkerUser;
};


const setSaveNewPositionWorker = async (dataPositionWorkerUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewPositionWorker/'),{
        dataPositionWorkerUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllPositionWorkerUser = data;

    // console.log('Сервер вернул данные по обновлению статуса PositionWorker  - ',response, dataPositionWorkerUpdate);


    return AllPositionWorkerUser;
};

Mock.onGet('/api/reference/getAllPositionWorker').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllPositionWorkerUser = await getAllPositionWorkerUser();
    // console.log('С сервера пришло - ', AllPositionWorkerUser);

    // if (!AllPositionWorkerUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllPositionWorkerUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPositionWorkerUser,
    ]


})


Mock.onPost('/api/reference/setActivePositionWorker').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllPositionWorkerUser = await setActivePositionWorker(id,val);

    // if (!AllPositionWorkerUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllPositionWorkerUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPositionWorkerUser,
    ]


})

Mock.onPost('/api/reference/setDeletedPositionWorker').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllPositionWorkerUser = await setDeletedPositionWorker(id,val);

    // if (!AllPositionWorkerUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllPositionWorkerUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPositionWorkerUser,
    ]


})


Mock.onPost('/api/reference/setUpdatePositionWorker').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataPositionWorkerUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const PositionWorker = await setUpdatePositionWorker(dataPositionWorkerUpdate);

    // console.log('Серовер вернул данные ',AllPositionWorkerUser);

    // if (!PositionWorker) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!PositionWorker) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        PositionWorker,
    ]


})


Mock.onPost('/api/reference/setSaveNewPositionWorker').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataPositionWorkerUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const PositionWorker = await setSaveNewPositionWorker(dataPositionWorkerUpdate);

    // console.log('Серовер вернул данные ',AllPositionWorkerUser);

    // if (!PositionWorker) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!PositionWorker) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        PositionWorker,
    ]
})